import React, { createContext, useContext } from 'react';

const OnboardingContext = createContext();
// Context object accepts a displayName string property.
// React DevTools uses this string to determine what to display for the context.
OnboardingContext.displayName = 'OnboardingContext';

export const useOnboardingContext = () => {
  const context = useContext(OnboardingContext);
  if (!context) {
    throw new Error(
      'useOnboardingContext must be used within the OnboardingContext.Provider'
    );
  }
  return context;
};

export const OnboardingContextProvider = (props) => (
  <OnboardingContext.Provider {...props} />
);

export default OnboardingContext;
